import { render, staticRenderFns } from "./VuetifyCal.vue?vue&type=template&id=74990e22&scoped=true"
import script from "./VuetifyCal.vue?vue&type=script&lang=js"
export * from "./VuetifyCal.vue?vue&type=script&lang=js"
import style0 from "./VuetifyCal.vue?vue&type=style&index=0&id=74990e22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74990e22",
  null
  
)

export default component.exports